import { useRef, useState } from "react";
import { ResourceAccessEnum } from "../../../../../../interfaces/general";
import { post, advancedResponseValidator } from "../../../../../../scripts/api";
import { handleAddToResources, handleSetDefaultSelectedItem, handleSetNewFolderModalStatus } from "../../../fileManager.actions";
import API from "../../../../../../urls/api";
import { forbiddenCharacters, getFileManagerParentId } from "../../../../../../scripts/helpers";
import TextInput from "../../../../textInput/textInput.index";
import { ButtonSize, ButtonType } from "../../../../button/button.interface";
import Button from "../../../../button/button.index";
import Dialog from "../../../../dialog/dialog.index";
import { toast } from "mobin-toast";
import { toastMessages } from "../../../../../../scripts/toastMessages";
import { useAppSelector } from "../../../../../../redux/hooks";
import { shallowEqual } from "react-redux";

export default function CreateNewFolderModal(): JSX.Element {
    const buttonRef = useRef<any>();
    const { newFolderModalStatus, resources } = useAppSelector(
        ({ fileManager: { newFolderModalStatus, resources } }) => ({ newFolderModalStatus, resources }),
        shallowEqual
    );
    const [folderName, setFolderName] = useState<string | null>(null);
    const [folderNameError, setFolderNameError] = useState<string>("");

    const handleCreateNewFolder = () => {
        return new Promise((resolve) => {
            if (folderName && folderName.length <= 250) {
                if (!folderName) {
                    setFolderNameError("نام پوشه را وارد کنید!");
                    resolve(true);
                } else if (forbiddenCharacters.some((item) => folderName.includes(item))) {
                    setFolderNameError(`از حروف غیرمجاز استفاده نکنید! (${forbiddenCharacters.join(" ")})`);
                    resolve(true);
                } else {
                    post(
                        (data, status) => {
                            resolve(true);
                            handleSetNewFolderModalStatus(false);
                            if (advancedResponseValidator(data, status)) {
                                if (resources) {
                                    handleSetDefaultSelectedItem([]);
                                    handleAddToResources({ ...data, shareData: { access: ResourceAccessEnum.WRITE } });
                                }
                                toast({ title: toastMessages(93, [folderName]), type: "success" });
                            }
                        },
                        API.fileManager.createFolder(),
                        { name: folderName, parent: getFileManagerParentId() }
                    );
                }
            } else resolve(true);
        });
    };

    return (
        <Dialog status={newFolderModalStatus} onClose={() => handleSetNewFolderModalStatus(false)} title="ایجاد پوشه جدید">
            <div
                className="p-4"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        buttonRef.current.click();
                    } else if (e.key === "Escape") {
                        handleSetNewFolderModalStatus(false);
                    }
                }}
            >
                <div className="relative">
                    <TextInput
                        label="نام پوشه"
                        placeholder=".نام پوشه خود را بنویسید"
                        onChange={(value) => {
                            if (value && value.length > 250) setFolderNameError("نام پوشه نباید بیشتر از ۲۵۰ کاراکتر باشد.");
                            else setFolderNameError("");
                            setFolderName(value);
                        }}
                        error={folderNameError}
                        autoFocus={true}
                    />
                    <div className="flex items-center absolute top-1 left-0 font-normal text-[12px]">
                        <div className="!text-[#A0A3BD] !font-bold !text-[10px]">{"250/"}</div>
                        {`${folderName ? folderName!.length : 0}`}
                    </div>
                </div>
                <div className="flex items-center gap-4 justify-end mt-8">
                    <Button
                        text="انصراف"
                        className="text-secondary-600"
                        size={ButtonSize.SM}
                        type={ButtonType.TEXT}
                        onClick={() => handleSetNewFolderModalStatus(false)}
                        autoFocus={false}
                    />
                    <Button
                        text="تایید"
                        size={ButtonSize.SM}
                        type={ButtonType.TEXT}
                        onClick={handleCreateNewFolder}
                        ref={buttonRef}
                        autoFocus={false}
                        disable={!!folderName && folderName.length > 250}
                    />
                </div>
            </div>
        </Dialog>
    );
}
